function checkforNestedGroups(input) {
  // console.log("Nested children", input[0], input[1], input)
  for (let i = 0; i < input.length; i++) {
    const children = input[i].children;
    // console.log("Nested children:", children)
    if (children) {
      for (let j = 0; j < children.length; j++) {
        if (children[j].type === 'group') {
          children.splice(j, 1);
        }
      }
    }
  }
}
// A function to add condition to state.groups
// returns a deep copy of updated input array.
function addCondition(input, groupId, conditionId) {
  for (let i = 0; i < input.length; i++) {
    if (input[i].id === groupId) {
      const groupCopy = { ...input[i] };
      groupCopy.children.push({
        id: conditionId,
        children: [],
        type: 'condition',
        option: 'include',
      });
      return input.filter((element, index) => {
        if (index !== i) return element;
        else return groupCopy;
      });
    }
  }
  // if condition was added from main container, it will not find anything
  // in the loop above, so this portion of code will be executed.
  const updatedGroups = [...input];
  updatedGroups.push({
    id: conditionId,
    children: [],
    type: 'condition',
    option: 'include',
  });
  return updatedGroups;
}

// A function to add condition to state.groups
// returns a deep copy of updated input array.
function removeCondition(input, groupId, conditionId) {
  for (let i = 0; i < input.length; i++) {
    if (input[i].id === groupId) {
      const groupCopy = { ...input[i] };
      const updatedChildren = groupCopy.children.filter(
        (element) => element.id !== conditionId
      );
      const updatedGroupCopy = { ...groupCopy, children: updatedChildren };
      // eslint-disable-next-line
      let result =  input.map((element, index) => {
        if (index !== i) return element;
        else if (updatedChildren.length > 0)return updatedGroupCopy;
      });
      result = result.filter(element => element !==undefined)
      return result
    }
  }
  // if condition was added from main container, it will not find anything
  // in the loop above, so this portion of code will be executed.
  const updatedGroups = [...input];
  updatedGroups.push({
    id: conditionId,
    children: [],
    type: 'condition',
    option: 'include',
  });
  return updatedGroups.filter((element) => element.id !== conditionId);
}

// function that remove a specified group (based on group_id) and cleans up all
//related conditions
function removeGroup(groups, conditions, id) {
  const newGroups = groups.filter((group) => {//eslint-disable-line
    if (group.id === id) {
      if (group.children && group.children.length > 0) {
        group.children.forEach((child) => {
          const removeId = child.id;
          delete conditions[removeId];
        });
      }
    } else {
      return group;
    }
  });
  return { newGroups, newConditions: conditions };
}

// Functions that checks and adjusts operators
// Makes changes "in place"
function adjustOperators(groups, operators) {
  let index = groups.length - 1;
  while (index >= 0) {
    const group = groups[index];
    // For each operator, check if it has neighbours
    if (group.type === 'operator') {
      if (
        !groups[index - 1] ||
        !groups[index + 1] ||
        groups[index - 1].type === 'operator' ||
        groups[index + 1].type === 'operator'
      ) {
        const operatorId = group.id;
        delete operators[operatorId];
        groups.splice(index, 1);
      }
      // For each group check if there are children in it, if so
      // recursively call the function
    }
    if (group.type === 'group' || group.type === 'condition') {
      if (group.children.length > 0) adjustOperators(group.children, operators);
      if (groups[index + 1] && groups[index + 1].type !== 'operator') {
        const id = Date.now();
        operators['operator-' + id] = {
          id: 'operator-' + id,
          type: 'operator',
          selected: true,
          filtered: true,
          value: 'OR',
        };
        const item = { id: 'operator-' + id, type: 'operator' };
        groups.splice(index + 1, 0, item);
      }
    }
    index--;
  }
}

export {
  checkforNestedGroups,
  addCondition,
  removeCondition,
  removeGroup,
  adjustOperators,
};
